import React from "react";

const Java_Enums = () => {
  return (
    <div>
      <h1>Java Enums</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Enums in Java.</p>
    </div>
  );
};

export default Java_Enums;
